/**
 * Replica of ObituaryType.php
 */
enum ObituaryType {
  /**
   * Basisvermelding
   */
  Basic = 1,
  /**
   * Normale advertentie
   */
  Regular = 0,
  /**
   * Uitgebreid (voorheen herdenkingspagina)
   */
  Extended = 2,
}
export default ObituaryType



export function getTitle (type: ObituaryType ){
  switch (type){
    case ObituaryType.Regular: return 'Online rouwpagina';
    case ObituaryType.Extended: return 'Herdenkingspagina';
  }
}
